module.exports = __webpack_public_path__ + "img/KNS-min.86e253d9.png";